"use strict";

require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.reflect.construct.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _commonStore = _interopRequireDefault(require("@audacious/web-common/lib/stores/common-store"));
(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};
var initialState = {
  settings: null
};
var SettingsStore = /*#__PURE__*/function (_CommonStore) {
  (0, _inherits2.default)(SettingsStore, _CommonStore);
  var _super = _createSuper(SettingsStore);
  function SettingsStore(dispatcher) {
    (0, _classCallCheck2.default)(this, SettingsStore);
    return _super.call(this, dispatcher, initialState);
  }
  (0, _createClass2.default)(SettingsStore, [{
    key: "setSettings",
    value: function setSettings(settings) {
      this.setState({
        settings: settings
      });
    }
  }, {
    key: "getSettings",
    value: function getSettings() {
      return this.state.settings;
    }
  }, {
    key: "getThreshold",
    value: function getThreshold() {
      var _this$state$settings, _this$state$settings$;
      return (_this$state$settings = this.state.settings) === null || _this$state$settings === void 0 ? void 0 : (_this$state$settings$ = _this$state$settings.notifications) === null || _this$state$settings$ === void 0 ? void 0 : _this$state$settings$.threshold;
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    value: // @ts-ignore
    function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);
  return SettingsStore;
}(_commonStore.default);
SettingsStore.storeName = 'SettingsStore';
SettingsStore.handlers = {
  SET_SETTINGS: 'setSettings'
};
var _default = SettingsStore;
var _default2 = _default;
exports.default = _default2;
;
(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;
  if (!reactHotLoader) {
    return;
  }
  reactHotLoader.register(initialState, "initialState", "/builds/audacious-inquiry/portfolio/prompt/prompt-application/clone/components/prompt-client/src/stores/settings-store.js");
  reactHotLoader.register(SettingsStore, "SettingsStore", "/builds/audacious-inquiry/portfolio/prompt/prompt-application/clone/components/prompt-client/src/stores/settings-store.js");
  reactHotLoader.register(_default, "default", "/builds/audacious-inquiry/portfolio/prompt/prompt-application/clone/components/prompt-client/src/stores/settings-store.js");
})();
;
(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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